import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { isMasteryFlowActive } from "../utils/masteryFlow";

const Practice = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Hide nav bar if on goalquestions route
  const hideNavBar =
    location.pathname.includes("goalquestions") ||
    location.pathname.includes("/practice/tutor");

  const workbookButtonClasses =
    "text-center py-3 px-6 rounded-4xl border-[0.5px] hover:border-[#0D99FF] hover:text-[#0D99FF] transition-colors";
  const practiceHeaderTitle = isMasteryFlowActive()
    ? "Test our Mastery"
    : "Let's get Practicing!";

  return (
    <div className="bg-white rounded-lg font-sans">
      {!hideNavBar && (
        <>
          <div className="bg-[#0D99FF] text-white p-4 sm:p-5 rounded-t-md flex justify-between items-center mb-5">
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => navigate(-1)}
                aria-label="Go back"
                className="text-white border border-white/30 rounded-full w-10 h-10 flex items-center justify-center hover:bg-white/10 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 18l-6-6 6-6"
                  />
                </svg>
              </button>

              <div>
                <h2 className="text-2xl font-semibold mb-1 text-white">
                  {practiceHeaderTitle}
                </h2>
                {/* <p className="text-sm opacity-90 text-white">
                  Set goals, choose topics, or play with friends - it's your turn!
                </p> */}
              </div>
            </div>
            {/* <img
              src="/assets/images/robot.png"
              alt="Robot Icon"
              className="w-10 h-15 object-contain"
            /> */}
          </div>
          {/* <div className="flex flex-wrap  gap-4 px-4 py-2 ">
            <NavLink
              to="mygoals"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              My Goals
            </NavLink>
            <NavLink
              to="tutor"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              Doubt Solving
            </NavLink>
            <button
              type="button"
              onClick={() =>
                navigate("/practice/tutor?enableWorkbookmode=true")
              }
              className={workbookButtonClasses}
            >
              Workbooks & PYQs
            </button>
            <NavLink
              to="notes"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              Notes Practice
            </NavLink>
            <NavLink
              to="teachMeTopic"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              Teach Me a Topic
            </NavLink>
            <NavLink
              to="explorer"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
              onClick={() => ""}
            >
              Topic Explorer
            </NavLink>

            <NavLink
              to="sampleWorksheet"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              Adaptive Worksheets
            </NavLink>
            <NavLink
              to="evaluateAnswerSheet"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              Evaluate Answer Sheets
            </NavLink>
            <NavLink
              to="samplePapers"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              Sample Paper
            </NavLink>
            <NavLink
              to="playwithfriends"
              end
              className={({ isActive }) =>
                isActive
                  ? "bg-[#0D99FF]  text-white py-3 px-6 rounded-4xl "
                  : " text-center  py-3 px-6 rounded-4xl  border-[0.5px]"
              }
            >
              Play with friend
            </NavLink>
          </div> */}
        </>
      )}
      <Outlet />
    </div>
  );
};

export default Practice;
